import { Flex } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaForm, RanaModal } from "@nens/ranalib";

import { cancelButtonText } from "@/translations";

import { useSubmitModelSchemaCatalogue } from "../hooks/use-submit-model-schema-catalogue";

interface ModelSchemaAddToCatalogueProps {
  fileId: string;
  isOpen: boolean;
  onClose: () => void;
  onCloseAll: () => void;
}

export function ModelSchemaAddToCatalogue({
  fileId,
  isOpen,
  onClose,
  onCloseAll,
}: ModelSchemaAddToCatalogueProps) {
  const intl = useIntl();

  const { submitToCatalogue, isMutating } = useSubmitModelSchemaCatalogue({
    fileId,
    onCloseAll,
  });

  return (
    <RanaForm
      initialValues={{ name: "", description: "" }}
      required={["name"]}
      doSubmit={submitToCatalogue}
    >
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={
          <FormattedMessage
            id="projectfile.add_a_new_model_schema"
            defaultMessage="Add a new model schematisation to the catalogue"
          />
        }
        maxW="xl"
        buttons={[
          {
            children: cancelButtonText,
            variant: "tertiary",
            isDisabled: isMutating,
            onClick: onClose,
          },
          <RanaForm.SubmitButton key="submit-button" isDisabled={isMutating}>
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </RanaForm.SubmitButton>,
        ]}
      >
        <Flex flexDir="column" gap={2}>
          <RanaForm.Input
            submitOnEnter={false}
            autoFocus
            field="name"
            label={intl.formatMessage({ id: "label.name", defaultMessage: "Name" })}
            placeholder={intl.formatMessage({
              id: "projectfile.schematisation_name.placeholder",
              defaultMessage: "Name of your model schematisation",
            })}
            isRequired
          />
          <RanaForm.Textarea
            w="full"
            field="description"
            label={intl.formatMessage({ id: "label.description", defaultMessage: "Description" })}
            placeholder={intl.formatMessage({
              id: "projectfile.schematisation_description.placeholder",
              defaultMessage:
                "Description for this model schematisation. This text will appear in the catalogue.",
            })}
            rows={6}
            isRequired
          />
          <RanaForm.Errors />
        </Flex>
      </RanaModal>
    </RanaForm>
  );
}
